import { useLoyaltyExternalOffersEmptyStatesQuery } from 'generated/sanity-graphql';
import { useFeaturesContext } from 'state/features';

export const useLoyaltyExternalOffersEmptyStates = () => {
  const { featureLoyaltyExternalOffersId = '', featureIdsLoading } = useFeaturesContext();

  const { data, loading } = useLoyaltyExternalOffersEmptyStatesQuery({
    variables: {
      id: featureLoyaltyExternalOffersId,
    },
    skip: !featureLoyaltyExternalOffersId,
  });

  const externalOffersEmptyStates = data?.LoyaltyLiveExternalOffers?.externalOffersEmptyState;

  return {
    externalOffersEmptyStates,
    externalOffersEmptyStatesLoading: loading || featureIdsLoading,
  };
};
